export default {
  resolve: function resolve(iconName) {
    return {
      id: "v2-icon-".concat(iconName),
      className: ''
    };
  }
};